import _merge from 'lodash/merge';
import _get from 'lodash/get';
import { Lightning, Router } from '@lightningjs/sdk';
import config from '@bedrock-rdk/config';
import { getSvgTexture } from '@tornado-rdk/icons';
import { t } from '../i18n';
import { removeSplashScreen } from '../../logic/app/app.utils';
import { getInitialStyle, QR_CODE_IMAGE_SIZE } from './qrCode.style';
import { getPageTranslationKey } from './qrCode.utils';
import { getScreenSize } from '../tornado/utils/sizes';
import { CORE_PATH } from '../routes/routes.utils';

// NOTE: qrcode is only reachable from the QR and pairing screens, so it is loaded on demand.
const loadQRCode = () =>
  import(
    /* webpackChunkName: "vendor.qrcode" */
    'qrcode'
  ).then(module => module.default);

export class QRCodePage extends Lightning.Component {
  static _template() {
    return _merge({}, getInitialStyle());
  }

  _active() {
    removeSplashScreen();

    const pageName = Router.getActiveRoute().replace(`${CORE_PATH}/`, '');
    const codeUrl = _get(config, `qrCode.links.${pageName}.long`);
    const shortUrl = _get(config, `qrCode.links.${pageName}.short`);
    const translationKey = getPageTranslationKey(pageName);

    const screenSize = getScreenSize();
    loadQRCode()
      .then(QRCode => QRCode.toDataURL(codeUrl, { margin: 2, width: QR_CODE_IMAGE_SIZE[screenSize].w }))
      .then(dataUrl => {
        const texture = getSvgTexture(dataUrl, QR_CODE_IMAGE_SIZE[screenSize].w, QR_CODE_IMAGE_SIZE[screenSize].h);
        this.tag('Code').texture = texture;
      });

    this.patch({
      Content: {
        PageTitle: { text: { text: t(`${translationKey}.title`) } },
        QRCodeWrapper: {
          Title: {
            text: { text: t(`${translationKey}.qrcode.title`) },
          },
          Info: {
            text: {
              text: `${t(`${translationKey}.qrcode.infos`)} <b>${shortUrl}</b>`,
            },
          },
        },
      },
    });
  }
}
